"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var theme_1 = __importDefault(require("../../theme"));
var styles_1 = require("./styles");
var NUM_OF_DOTS = 3;
/**
 * Renders an animated three dots loader.
 * @param color Optional string param that gives the fill color of the loader.
 */
function Loader(_a) {
    var _b = _a.color, color = _b === void 0 ? theme_1.default.colorsPalette.white.default : _b;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.MainContainer, null, __spreadArray([], Array(NUM_OF_DOTS), true).map(function (_, i) { return (react_1.default.createElement(styles_1.Dot, { key: i, delay: "0.".concat(i, "s"), backgroundColor: color })); }))));
}
exports.default = Loader;
//# sourceMappingURL=index.js.map